import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { PreviewChatComponent } from '../preview-chat/preview-chat.component';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit {
  @Output() pageChanged = new EventEmitter();
  public messages = [];
  private _actualPage = 1;
  private _totalPages = 1;

  get totalPages() {
    return this._totalPages;
  }

  get actualPage() {
    return this._actualPage;
  }

  constructor(private _httpSv: HttpService, private _uiSv: UiServices) {}

  async ngOnInit() {
    await this.getMessages();
  }

  async getMessages() {
    const params = {
      pag: this._actualPage,
    };
    const res = await this._httpSv.itemIndex('talk', '', params);
    const data = res.data;
    this.messages = data.data;
    this._totalPages = data.meta.last_page;
  }

  async changePage(ev) {
    this._actualPage = ev;
    await this.getMessages();
    this.pageChanged.emit();
  }

  openChat(message) {
    if (!message.talkSelected?.length) {
      return this._uiSv.presentAlert('No hay ningun mensaje registrado');
    }
    this._uiSv.showModal(
      PreviewChatComponent,
      {
        messages: message.talkSelected,
      },
      'messages-comp'
    );
  }

  trackByItems(index, item) {
    return item.id;
  }
}
